import React from 'react';
import { Button, Input } from 'antd';
import { DeleteOutlined } from '@ant-design/icons';
import { VariationOptionProps } from '../types';
import { OptionContainer, DragHandle } from '../styles';

export const VariationOption: React.FC<VariationOptionProps & { disabled?: boolean }> = React.memo(({
  option,
  onDelete,
  onChange,
  disabled,
  ...props
}) => {
  const {
    'data-option-id': dataOptionId,
    placeholder,
    status,
    onKeyPress,
  } = props;

  const inputProps = {
    value: option.value,
    onChange: disabled ? undefined : onChange,
    placeholder,
    status,
    onKeyPress: disabled ? undefined : onKeyPress,
    'data-option-id': dataOptionId,
    disabled,
  };

  return (
    <OptionContainer>
      <DragHandle style={{ cursor: disabled ? 'not-allowed' : 'move' }} />
      <Input {...inputProps} />
      {onDelete && !disabled && (
        <Button type="text" icon={<DeleteOutlined />} onClick={onDelete} />
      )}
    </OptionContainer>
  );
});

export default VariationOption; 